import type * as React from "react";
import { cn } from "../utils/mergeClassNames";

const styles = {
  xs: "mx-auto px-2 sm:px-6 md:max-w-2xl md:px-4 lg:px-4",
  sm: "mx-auto px-2 sm:px-6 md:max-w-3xl md:px-4 lg:max-w-4xl lg:px-16",
  md: "mx-auto px-2 sm:px-6 md:max-w-4xl md:px-4 lg:max-w-5xl lg:px-16",
  lg: "mx-auto px-2 sm:px-6 md:max-w-4xl md:px-4 lg:max-w-screen-xl lg:px-18",
};

interface IContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
  children: React.ReactNode;
}

const Container = ({ size = "lg", className, ...props }: IContainerProps) => {
  return (
    <div
      className={cn(styles[size], "relative", className)}
      {...props}
    />
  );
};
Container.displayName = "Container";

export { Container };
